import {ResourcesClient} from "./../resources.client";
import {NgModule} from "@angular/core";
import {Http, RequestOptions, XHRBackend} from "@angular/http";
import {httpFactory} from "@digicerba/common";
import {HttpClient, IAuthenticationPublicWebServiceClient} from "./resources.auth";


var resources: Array<any> = [
  /** Liste des resources du fichier resources.ts*/
  IAuthenticationPublicWebServiceClient
];

@NgModule({
  providers: [...resources, {
    provide: Http,
    useFactory: httpFactory,
    deps: [XHRBackend, RequestOptions]
  },
    {provide: HttpClient, useClass: ResourcesClient}]
})
export class ResourcesAuthModule {

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/common/resources/auth/resources.auth.module.ts